import { render, staticRenderFns } from "./MinigenresData.vue?vue&type=template&id=1d32539c&scoped=true&"
import script from "./MinigenresData.vue?vue&type=script&lang=js&"
export * from "./MinigenresData.vue?vue&type=script&lang=js&"
import style0 from "./MinigenresData.vue?vue&type=style&index=0&id=1d32539c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d32539c",
  null
  
)

export default component.exports